import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import { Minus, Plus, Trash2 } from "lucide-react";
import { formatCurrency } from "@/lib/api";
import { useStore } from "@/context/StoreContext";

export function CartDrawer({ open, onOpenChange, onCheckout }) {
  const { cart, updateQuantity, removeFromCart, subtotal } = useStore();
  const shipping = subtotal >= 20000 || subtotal === 0 ? 0 : 499;

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent className="w-full border-white/10 bg-void p-0 text-foreground sm:max-w-lg" data-testid="cart-drawer">
        <SheetHeader className="border-b border-white/10 p-6 text-left">
          <SheetTitle className="font-heading text-4xl font-black italic">Your edit</SheetTitle>
          <SheetDescription className="text-zinc-500">Objects currently held in your cart.</SheetDescription>
        </SheetHeader>
        <div className="h-[calc(100vh-240px)] overflow-y-auto p-6">
          {cart.length === 0 ? (
            <div data-testid="empty-cart-message" className="grid h-full place-items-center text-center text-zinc-500">Your cart is waiting for its first obsession.</div>
          ) : cart.map((item) => (
            <div key={item.id} data-testid={`cart-item-${item.id}`} className="mb-6 flex gap-4 border-b border-white/10 pb-6">
              <img src={item.image_url} alt={item.name} className="h-28 w-24 object-cover" />
              <div className="flex-1">
                <div className="flex justify-between gap-4">
                  <h3 className="font-subheading text-lg font-bold">{item.name}</h3>
                  <button data-testid={`remove-cart-item-${item.id}`} onClick={() => removeFromCart(item.id)} className="text-zinc-500 transition-colors hover:text-neon"><Trash2 size={17} /></button>
                </div>
                <p className="mt-2 text-volt">{formatCurrency(item.price)}</p>
                <div className="mt-4 flex w-fit items-center border border-white/10">
                  <button data-testid={`decrease-quantity-${item.id}`} onClick={() => updateQuantity(item.id, -1)} className="p-2"><Minus size={14} /></button>
                  <span data-testid={`cart-quantity-${item.id}`} className="w-10 text-center text-sm">{item.quantity}</span>
                  <button data-testid={`increase-quantity-${item.id}`} onClick={() => updateQuantity(item.id, 1)} className="p-2"><Plus size={14} /></button>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="absolute bottom-0 left-0 w-full border-t border-white/10 bg-void p-6">
          <div className="mb-4 space-y-2 text-sm text-zinc-400">
            <div className="flex justify-between"><span>Subtotal</span><span data-testid="cart-subtotal">{formatCurrency(subtotal)}</span></div>
            <div className="flex justify-between"><span>Shipping</span><span data-testid="cart-shipping">{shipping === 0 ? "Free" : formatCurrency(shipping)}</span></div>
          </div>
          <Button data-testid="checkout-button" onClick={onCheckout} disabled={cart.length === 0} className="kinetic-button h-13 w-full rounded-none bg-volt py-4 font-bold uppercase tracking-[0.2em] text-black hover:bg-transparent hover:text-volt">
            Checkout / {formatCurrency(subtotal + shipping)}
          </Button>
        </div>
      </SheetContent>
    </Sheet>
  );
}
